import { API } from 'shared/constants/api';
import { appApi } from '../api';
import { B2BDeliveryOrder, B2BOrderArgs, EstimateFeeResponse } from './types';

export const orderApi = appApi.injectEndpoints({
  endpoints: (builder) => ({
    createB2BOrder: builder.mutation<any, B2BOrderArgs<B2BDeliveryOrder>>({
      query: (data) => ({
        url: API.order.b2b_create,
        method: 'POST',
        data,
      }),
    }),
    estimateB2BOrderFee: builder.mutation<
      EstimateFeeResponse,
      B2BOrderArgs<Omit<B2BDeliveryOrder, 'total_pay' | 'e_invoice'>>
    >({
      query: (data) => ({
        url: API.order.b2b_estimate,
        method: 'POST',
        data,
      }),
    }),
  }),
});

export const { useCreateB2BOrderMutation, useEstimateB2BOrderFeeMutation } =
  orderApi;
